import { useTheme } from 'next-themes';
import { memo } from 'react';

import { Palette } from '@air/next-icons';
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
} from '@air/primitive-dropdown-menu';

export const WorkspaceHeaderInformationDropdownThemeItems = memo(() => {
  const { theme, setTheme } = useTheme();

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuSub label="Color theme" prefix={<Palette className="size-4" />} size="small">
        <DropdownMenuRadioGroup value={theme} onValueChange={setTheme}>
          <DropdownMenuRadioItem label="System" size="small" value="system" />
          <DropdownMenuRadioItem label="Light mode" size="small" value="light" />
          <DropdownMenuRadioItem label="Dark mode" size="small" value="dark" />
        </DropdownMenuRadioGroup>
      </DropdownMenuSub>
    </>
  );
});

WorkspaceHeaderInformationDropdownThemeItems.displayName = 'WorkspaceHeaderInformationDropdownThemeItems';
